/**
 * @generated SignedSource<<070763a24ba9ce273b9d4afccca9ef48>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type TopicDeleteButtonFragment$data = {
  readonly __id: string;
  readonly forum: {
    readonly id: string;
    readonly owner: {
      readonly forumOwnerKind: ForumOwnerKind;
      readonly slug: string;
    };
    readonly slug: string;
  };
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "TopicDeleteButtonFragment";
};
export type TopicDeleteButtonFragment$key = {
  readonly " $data"?: TopicDeleteButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicDeleteButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicDeleteButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forumOwnerKind",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "e3ecfbea695168d5f51178d4ddfa3495";

export default node;
